// Route wrapper: /sites/{siteId}/{tab}[/{channel}] makes the active tab + log
// channel addressable (linkable/bookmarkable/refresh-safe, Back steps between
// tabs). SiteDrilldownView stays router-free (props only) so its tabs are unit-testable without a router.
import { useNavigate, useParams, useSearch } from '@tanstack/react-router';
import { SiteDrilldownView, isTabKey, type TabKey } from './SiteDrilldownView';

export function SiteDrilldown() {
  const params = useParams({ strict: false });
  const search = useSearch({ strict: false }) as { job?: string; session?: string };
  const navigate = useNavigate();
  const siteId = params.siteId ?? '';
  // Unknown/absent tab falls back to Status (not blank) so a stale bookmark to a removed tab still shows the site.
  const tab: TabKey = isTabKey(params.tab) ? params.tab : 'status';
  const channel = params.channel ?? null;

  return (
    <SiteDrilldownView
      siteId={siteId}
      tab={tab}
      onTabChange={(next) =>
        void navigate({ to: '/sites/$siteId/$tab', params: { siteId, tab: next } })
      }
      channel={channel}
      onChannelChange={(next) =>
        void navigate(
          next
            ? {
                to: '/sites/$siteId/$tab/$channel',
                params: { siteId, tab: 'logs', channel: next },
              }
            : { to: '/sites/$siteId/$tab', params: { siteId, tab: 'logs' } },
        )
      }
      jobId={search.job ?? null}
      onJobChange={(next) =>
        void navigate({
          to: '/sites/$siteId/$tab',
          params: { siteId, tab: 'updates' },
          search: next ? { job: next } : {},
        })
      }
      session={search.session ?? null}
      onSessionChange={(next) =>
        void navigate({
          to: '/sites/$siteId/$tab',
          params: { siteId, tab: 'editor' },
          search: next ? { session: next } : {},
        })
      }
    />
  );
}
